import Masonry from 'masonry-layout';
import PopupEquipment from '../modules/popupEquipment';

$ = jQuery;
export default class EquipmentCardsSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.wrapper = this.root.querySelector('[data-equipment-cards-grid]');
        this.cards = this.root.querySelectorAll(
            '[data-equipment-cards-grid-item]'
        );
        this.masonry = null;

        return true;
    }

    init() {
        //this.gridHandler();
        //this.onResize();
        this.setCards();
    }

    onResize() {
        window.addEventListener('resize', this.gridHandler.bind(this));
    }

    gridHandler() {
        const { innerWidth } = window;
        let gutter = innerWidth < 768 ? 16 : 24;
        if (innerWidth < 576) gutter = 0;

        const sizer = this.wrapper.querySelector('.grid-sizer');
        this.masonry = new Masonry(this.wrapper, {
            columnWidth: sizer,
            itemSelector: '.equipment-cards__item',
            gutter,
            percentPosition: true,
            horizontalOrder: true,
        });
    }

    setCards() {
        if (!this.cards) return;
        this.cards.forEach(item => {
            item.addEventListener('click', this.onCardClick.bind(this));
        });
    }

    setPopup() {
        const popup = document.querySelector('[data-popup]');
        if (popup) this.popupInstance = new PopupEquipment(popup);
    }

    onCardClick(event) {
        this.cards.forEach(oneCard => oneCard.classList.add('-blocked'));
        const { currentTarget } = event;
        const data = JSON.parse(
            currentTarget.getAttribute('data-equipment-cards-grid-item')
        );

        const formData = new FormData();
        formData.append('action', 'equipment_popup');

        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
        });

        $.ajax({
            type: 'POST',
            url: ajax.url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const data = JSON.parse(response);
                const { html } = data;

                document.body.insertAdjacentHTML('beforeend', html);
                this.setPopup();
            }.bind(this),
            error: function () {}.bind(this),
            complete: function () {
                this.cards.forEach(oneCard =>
                    oneCard.classList.remove('-blocked')
                );
            }.bind(this),
        });
    }
}
